import {getRequest, sendRequest} from './api';

/**
 * Обновление данных пользователя.
 * @param {object} data - Объект с данными для обновления (обязательное поле id).
 * @param password, last_name, first_name, patronymic, phone, email не обязательные.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function getUserData(data) {
  return getRequest('/user', data); // Используем относительный путь
}
/**
 * Обновление данных пользователя.
 * @param {object} data - Объект с данными для обновления (обязательное поле id).
 * @param password, last_name, first_name, patronymic, phone, email не обязательные.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function updateUser(data) {
  return sendRequest('/user', 'PUT', data); // Используем относительный путь
}

/**
 * Обновление данных пользователя.
 * @param {object} data - Объект с данными для обновления (organisation_id, active_only=true/false.).
 * @param password, last_name, first_name, patronymic, phone, email не обязательные.
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function getUserRole(data) {
  return getRequest('/user/role', data); // Используем относительный путь
}
